export const useAuthStore = defineStore("auth", () => {
  const {
    login: apiLogin,
    verification: apiVerification,
    getProfile: apiGetUser,
    resetPassword: apiResetPassword,
    logout: apiLogout,
  } = useAuth();
  const router = useRouter();

  const token = ref(localStorage.getItem("token"));
  const user = ref({});
  const userLoaded = ref(false);

  const login = async (payload) => {
    const data = await apiLogin(payload);
    if (data) {
      setToken(data.token);
      setUser(data);
      router.replace({ name: "user.home" });
    }
  };

  const verification = async (payload) => {
    const data = await apiVerification(payload);
    if (data) {
      setToken(data.token);
      setUser(data);
      router.replace({ name: "user.home" });
    }
  };

  const resetPassword = async (payload) => {
    const data = await apiResetPassword(payload);
    if (data) {
      setToken(data.token);
      setUser(data);
      router.replace({ name: "user.home" });
    }
  };

  const fetchUser = async () => {
    if (userLoaded.value) return;
    if (token.value)
      axios.defaults.headers.common["Authorization"] = "Bearer " + token.value;
    const data = await apiGetUser();
    if (data) {
      userLoaded.value = true;
      setUser(data);
    }
  };

  const logout = async () => {
    const response = await apiLogout();
    if (!response.error) {
      reset();
      router.push({ name: "login" });
    }
  };

  const reset = () => {
    localStorage.removeItem("token");
    user.value = {};
    token.value = null;
    userLoaded.value = false;
  };

  const check = () => Boolean(token.value?.trim());

  const setToken = (value) => {
    token.value = value;
    localStorage.setItem("token", value);
  };

  const setUser = (data) => (user.value = data);

  return {
    token,
    user,
    userLoaded,
    login,
    fetchUser,
    verification,
    logout,
    resetPassword,
    setUser,
    check,
    reset,
  };
});
